import { Box, Text } from "grommet";
import { useRouter } from "next/router";
import { useIsLarge } from "@cybertools/grommet/useIsLarge";
import Pagination from "@components/pagination";
import getPage from "@helpers/getPage";
import { pageSize } from "@organisms/coin/helpers";
import CoinList from "@organisms/airdrop/list/list";
import Container from "./container";

export const seoByType = {
  active: {
    title: "Active Airdrops",
    short: "Active",
    description: "Active airdrops in Coinscope",
  },
  upcoming: {
    title: "Upcoming Airdrops",
    short: "Upcoming",
    description: "Upcoming airdrops in Coinscope",
  },
  finished: {
    title: "Finished Airdrops",
    short: "Finished",
    description: "Finished airdrops in Coinscope",
  },
  default: {
    title: "Airdrops",
    description: "Coins running airdrop in Coinscope",
  },
};

export default function Airdrop({ coinSlugs, totalCoins, ...rest }) {
  const large = useIsLarge();
  const router = useRouter();
  const page = getPage(router.query.page);
  const type = router.query.type || "default";

  const pushRouter = ({ nextPage = page }) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, page: nextPage },
    });
  };

  const onPageChange = (page) => pushRouter({ nextPage: page });

  const seo = seoByType[router.query.type] || seoByType.default;

  const breadcrumb = [
    { label: "Airdrops", title: "Airdrops", href: "/airdrop" },
    type !== "default" && { label: seo.short, title: seo.short },
  ].filter(Boolean);

  return (
    <Container
      seo={seo}
      breadcrumb={breadcrumb}
      subtitle="To participate to an active airdrop, click on a token from the list and follow the steps in the form."
      {...rest}
    >
      <Box height={{ min: "400px" }}>
        {coinSlugs.length === 0 && (
          <Text textAlign="center" margin={{ top: "120px" }}>
            There are no airdrops right now
          </Text>
        )}

        {coinSlugs.length > 0 && (
          <CoinList
            gaCategory={`airdrop${type}`}
            slugs={coinSlugs}
            margin={{ top: large ? "small" : "xsmall" }}
            firstIndex={(page - 1) * pageSize}
            navigate="/airdrop"
          />
        )}
        {totalCoins > pageSize && (
          <Pagination
            page={page}
            onChange={onPageChange}
            step={pageSize}
            numberItems={totalCoins}
            margin={{ top: "medium" }}
          />
        )}
      </Box>
    </Container>
  );
}
